// Composant pour générer les cartes de projets
function createProjectCard(project) {
  return `
    <article class="project-card">
      <div class="project-content">
        <h3 class="text-xl font-bold mb-2">${project.title}</h3>
        <p class="text-gray-400 mb-4">${project.description}</p>
        <div class="flex flex-wrap gap-2 mb-4">
          ${project.technologies.map(tech => `<span class="tech-pill">${tech}</span>`).join('')}
        </div>
        <div class="flex justify-between items-center">
          <a href="project-details.html?id=${project.id}" class="text-blue-400 hover:text-blue-300 transition-colors">
            Voir le projet →
          </a>
          <div class="flex space-x-4">
            <a href="${project.repoUrl}" target="_blank" class="text-gray-400 hover:text-blue-400 transition-colors">
              <i class="fab fa-github"></i>
            </a>
            <a href="${project.demoUrl}" target="_blank" class="text-gray-400 hover:text-blue-400 transition-colors">
              <i class="fas fa-external-link-alt"></i>
            </a>
          </div>
        </div>
      </div>
    </article>
  `;
}

if (typeof window !== 'undefined') {
  window.createProjectCard = createProjectCard;
}